module.exports = require('jquery')
